import { render, staticRenderFns } from "./supervisingTeacherDialog.vue?vue&type=template&id=493881b0&scoped=true"
import script from "./supervisingTeacherDialog.vue?vue&type=script&lang=js"
export * from "./supervisingTeacherDialog.vue?vue&type=script&lang=js"
import style0 from "./supervisingTeacherDialog.vue?vue&type=style&index=0&id=493881b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493881b0",
  null
  
)

export default component.exports